
const { JSableMixin } = require('./jsable');


const JSableOmitPrivateMixin = (superclass) => {
	return class JSableOmitPrivate extends JSableMixin(superclass) {
		_toFromJSOmit (v, k) {
			return super._toFromJSOmit(...arguments)
				|| typeof k !== 'string'
				|| k.startsWith('_');
		}
	};
};

const JSableOmitPrivate = JSableOmitPrivateMixin(class {});


module.exports = { JSableOmitPrivateMixin, JSableOmitPrivate };

